import { Component, OnInit } from '@angular/core';
import { MenuItemsService } from '../../services/menu-items.service';
import { MenuItem } from '../../interfaces/menu-item';
import * as Query from '../../global-query';
import { PagerService } from '../../services/pager-service';
import { AppsyncService } from '../../services/appsync.service';
import 'rxjs/add/operator/map';
import listMenu from '../../graphql/queries/listMenu';
import update from 'immutability-helper';
import NewItemSubscription from '../../graphql/subscriptions/NewItemSubscription';
import DeleteItemSubscription from '../../graphql/subscriptions/DeleteItemSubscription';
import UpdateItemSubscription from '../../graphql/subscriptions/UpdateItemSubscription';

import { LoaderService } from '../../pages/loader/loader.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  public menuItems: MenuItem[];
  public searchInput: any;
  public repos = [];
  public busy = false;
  public page = 1;
  public end = 250;
  public numberToDisplay = 20;
  public filter: string;
  // pager object
  pager: any = {};
  p = 1;

  // paged items
  pagedItems: any[];

  public slides = [];

  // array of all items to be paged
  private allItems: any[];

  constructor(
    private menuService: MenuItemsService,
    private pagerService: PagerService,
    private appsync: AppsyncService,
    private loaderService: LoaderService
  ) {}

  ngOnInit() {
    this.getItemList();
  }

  loadMore() {
    /*const last = this.menuItems[this.menuItems.length - 1];
    const data = this.menuItems.slice(this.page, this.end);
    this.page = this.page + 250;
    this.end = this.end + 250;
    this.repos = this.repos.concat(data);*/

    if (this.numberToDisplay + 5 < this.menuItems.length) {
      this.numberToDisplay += 5;
    } else {
      this.numberToDisplay = this.menuItems.length;
    }
  }

  getItemList() {
    this.appsync.client.hydrated().then((client) => {
      this.loaderService.show();

      const observable = client.watchQuery({
        query: listMenu,
        fetchPolicy: 'cache-and-network'
      });

      observable.subscribe(
        ({ data }) => {
          if (!data) {
            return console.log('listMenu - no data');
          }

          this.loaderService.hide();

          this.menuItems = data.listMenu;
          this.loadMore();
          // this.setPage(1);
        },
        (error) => {}
      );

      observable.subscribeToMore({
        document: NewItemSubscription,
        updateQuery: (
          prev,
          {
            subscriptionData: {
              data: { onCreateItem: item }
            }
          }
        ) => {
          console.log('Subscription Home add', prev, item);
          if (!prev || !prev.listMenu) {
            return { listMenu: [] };
          }

          if (prev.listMenu.find((_item) => _item.id === item.id)) {
            return prev;
          }

          return update(prev, { listMenu: { $push: [item] } });
        }
      });

      observable.subscribeToMore({
        document: UpdateItemSubscription,
        updateQuery: (
          prev,
          {
            subscriptionData: {
              data: { onUpdateItem: item }
            }
          }
        ) => {
          console.log('Subscription Home update', prev, item);
          if (!prev || !prev.listMenu) {
            return { listMenu: [] };
          }
          // Find the updated item
          const updatedId = item.id;
          const index = prev.listMenu.findIndex((menu) => menu.id === updatedId);

          return update(prev, {
            listMenu: {
              [index]: {
                subset: {
                  $set: [item]
                }
              }
            }
          });
        }
      });

      observable.subscribeToMore({
        document: DeleteItemSubscription,
        updateQuery: (
          prev,
          {
            subscriptionData: {
              data: { onDeleteItem: item }
            }
          }
        ) => {
          console.log('Subscription Home delete', prev, item);

          if (!prev || !prev.listMenu) {
            return { listMenu: [] };
          }

          return update(prev, { listMenu: (arr) => arr.filter((_item) => _item.id != item.id) });
        }
      });
    });
  }

  setPage(page: number) {
    let _pageSize: number;
    _pageSize = 12;

    // get pager object from service
    this.pager = this.pagerService.getPager(this.menuItems.length, page, _pageSize);

    if (page < 1 || page > this.pager.totalPages) {
      this.pagedItems = [];
      return;
    }

    // get current page of items
    this.pagedItems = this.menuItems.slice(this.pager.startIndex, this.pager.endIndex + 1);

    // window.scrollTo(0, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/menu/menu.component.ts